import { render, staticRenderFns } from "./ConveyorBeltIcon.vue?vue&type=template&id=22cc7c12"
import script from "./ConveyorBeltIcon.vue?vue&type=script&lang=js"
export * from "./ConveyorBeltIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports